export const SET_STATUS = 'RETRANSMISSION_STATUS_SET_STATUS';
export const SET_LOADING = 'RETRANSMISSION_STATUS_SET_LOADING';
export const SET_DEVICES = 'RETRANSMISSION_STATUS_SET_DEVICES';
export const SET_ERROR = 'RETRANSMISSION_STATUS_SET_ERROR';
export function setStatus(status) {
    return {
        type: SET_STATUS,
        payload: { status },
    };
}
export function setLoading(isLoading, target = 'status') {
    return {
        type: SET_LOADING,
        payload: { isLoading, target },
    };
}
export function setDevices(channel, devices) {
    return {
        type: SET_DEVICES,
        payload: { channel, devices },
    };
}
export function setError(error, target = 'status') {
    return {
        type: SET_ERROR,
        payload: { error, target },
    };
}
